import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
    name: "auth",
    initialState: {
        token: null,
        user: null
    },
    reducers: {
        setToken: (state, action) => {
            return {
                ...state,
                token: action.payload
            }
        },
        setUser: (state, action) => {
            return {
                ...state,
                user: action.payload
            }
        },
    }
})

export const { setToken, setUser } = authSlice.actions
export default authSlice.reducer